import styles from './index.less';
import { List, PullRefresh } from 'react-vant';
import NoData from '@/components/NoData';
import { useRef, useState } from 'react';
import ListContainer from '@/components/ListContainer';
import StickyActiveButton from '@/components/StickyActiveButton';
import { history, useModel } from '@umijs/max';
import { queryMessageList } from '@/pages/ServicesMore/service';
import { LeaveMessageListType } from '@/pages/ServicesMore/interface';

const LeaveMessage = () => {
  const [finished, setFinished] = useState<boolean>(false);
  const pageNum = useRef(1);
  const [leaveMessageList, setLeaveMessageList] = useState<
    LeaveMessageListType[]
  >([]);
  const { defaultCustomerInformation } = useModel(
    'useDefaultCustomer',
    (model) => ({
      defaultCustomerInformation: model.defaultCustomerInformation,
    }),
  );

  const onLoadRefresh = async (isRefresh?: boolean) => {
    const res = await queryMessageList({
      current: pageNum.current,
      pageSize: 20,
      customerName: defaultCustomerInformation?.customerName,
    });
    const { code, rows, total } = res;
    if (code === 200) {
      setLeaveMessageList((prevState) => {
        const newList = isRefresh ? rows : [...prevState, ...rows];
        if (newList.length >= total!) {
          setFinished(true);
        }
        return newList;
      });
    }
  };

  const onRefresh = async () => {
    setFinished(false);
    await onLoadRefresh(true);
  };

  const jumpToMessagePage = () => {
    history.push('/message');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <PullRefresh onRefresh={onRefresh}>
          <List finished={finished} onLoad={onLoadRefresh}>
            {leaveMessageList.length !== 0 ? (
              <>
                {leaveMessageList.map((item) => (
                  <ListContainer key={item.sequenceNbr} listDetail={item} />
                ))}
              </>
            ) : (
              <NoData />
            )}
          </List>
        </PullRefresh>
      </div>
      <StickyActiveButton activeText={'留言'} activeClick={jumpToMessagePage} />
    </div>
  );
};

export default LeaveMessage;
